import React, { useState, useEffect } from "react";
import { InputGroup, Input } from "reactstrap";
import DatePicker from "react-datepicker";
import { Portal } from "react-overlays";
import moment from "moment";

// const CalendarContainer = ({ children }) => {
//   const el = document.getElementById("calendar-portal");
//   return <Portal container={el}>{children}</Portal>;
// };

const ColumnFilters = (props) => {
  const { col, onColumnFilterChange, reset } = props;
  const [filterValue, setFilterValue] = useState();
  const [filterType, setFilterType] = useState("");

  useEffect(() => {
    setFilterValue("");
    setFilterType("");
  }, [reset]);

  const handleInputChange = (e, col, type) => {
    setFilterValue(e.target.value);
    onColumnFilterChange(e, col, type,filterType);
  };

  // const handleDateChange = (date) => {
  //   const formatDate = moment(date).format("MM/DD/YYYY");
  //   setFilterValue(date);
  //   const event = { target: { value: formatDate } };
  //   console.log(event,"event value")
  //   onColumnFilterChange(event, col, "field",filterType);
  // };
  // Validate date components (month, day, year)
  const validateDate = (date) => {
    if (!date) return false;
    const datePickerInput = document.querySelector('.date-picker input');
    const rawInputValue = datePickerInput ? datePickerInput.value : '';
    
    if (rawInputValue) {
      const parts = rawInputValue.split('/');
      if (parts.length === 3) {
        const month = parseInt(parts[0], 10);
        const day = parseInt(parts[1], 10);
        const year = parts[2];
        
        if (isNaN(month) || month < 1 || month > 12) {
          return false;
        }
        
        if (year && year.length === 4) {
          const yearNum = parseInt(year, 10);
          if (isNaN(yearNum)) {
            return false;
          }
          if (yearNum < 1900 || yearNum > 9999) {
            return false;
          }
        } else if (year && year.length !== 4) {
          return false;
        }
        
        if (isNaN(day) || day < 1 || day > 31) {
          return false;
        }
        
        if (year && year.length === 4) {
          const yearNum = parseInt(year, 10);
          if (!isNaN(yearNum)) {
            const daysInMonth = new Date(yearNum, month, 0).getDate();
            if (day > daysInMonth) {
              return false;
            }
          }
        }
      }
    }
    
    const momentDate = moment(date);
    if (!momentDate.isValid()) {
      return false;
    }
    
    const year = momentDate.year();
    if (year.toString().length === 4) {
      const yearNum = parseInt(year.toString(), 10);
      if (isNaN(yearNum) || yearNum < 1900 || yearNum > 9999) {
        return false;
      }
    } else if (year.toString().length > 4) {
      return false;
    }
    
    const month = momentDate.month() + 1; 
    if (month < 1 || month > 12) {
      return false;
    }
    
    const day = momentDate.date();
    const daysInMonth = momentDate.daysInMonth();
    if (day < 1 || day > daysInMonth) {
      return false;
    }
    
    return true;
  };

  const handleDateChange = (date) => {
    if (!validateDate(date)) {
      setFilterValue(null);
      const event = { target: { value: "" } };
      onColumnFilterChange(event, col, "field", filterType);
      return;
    }
    
    const formatDate = moment(date).format("MM/DD/YYYY");
    setFilterValue(date);
    const event = { target: { value: formatDate } };
    // console.log(event,"event value")
    onColumnFilterChange(event, col, "field",filterType);
  };

  const handleDateRawChange = (e) => {
    const rawValue = e.target.value;
    const cursorPosition = e.target.selectionStart;
    
    // If empty, allow it
    if (!rawValue || rawValue.trim() === '') {
      return;
    }
    
    if (rawValue.length > 10) {
      e.preventDefault();
      e.target.value = rawValue.substring(0, 10);
      return;
    }
    
    const parts = rawValue.split('/');
    
    if (parts.length >= 1) {
      const month = parts[0];
      
      if (month && month.length > 2) {
        e.preventDefault();
        e.target.value = '';
        setFilterValue(null);
        const event = { target: { value: "" } };
        onColumnFilterChange(event, col, "field", filterType);
        setTimeout(() => {
          e.target.setSelectionRange(0, 0);
        }, 0);
        return;
      }
      
      if (month && month.length === 2) {
        const monthNum = parseInt(month, 10);
        if (monthNum > 12 || monthNum < 1) {
          e.preventDefault();
          e.target.value = '';
          setFilterValue(null);
          const event = { target: { value: "" } };
          onColumnFilterChange(event, col, "field", filterType);
          setTimeout(() => {
            e.target.setSelectionRange(0, 0);
          }, 0);
          return;
        }
      }
      
      if (month && month.length === 1 && cursorPosition === 2) {
        const nextChar = rawValue.charAt(1);
        if (nextChar && nextChar !== '/') {
          const potentialMonth = parseInt(month + nextChar, 10);
          if (potentialMonth > 12 || potentialMonth < 1) {
            e.preventDefault();
            e.target.value = month;
            setFilterValue(null);
            const event = { target: { value: "" } };
            onColumnFilterChange(event, col, "field", filterType);
            setTimeout(() => {
              e.target.setSelectionRange(1, 1);
            }, 0);
            return;
          }
        }
      }
    }
    
    if (parts.length >= 2) {
      const day = parts[1];
      
      if (day && day.length > 2) {
        e.preventDefault();
        e.target.value = '';
        setFilterValue(null);
        const event = { target: { value: "" } };
        onColumnFilterChange(event, col, "field", filterType);
        setTimeout(() => {
          e.target.setSelectionRange(0, 0);
        }, 0);
        return;
      }
      
      if (day && day.length === 2) {
        const dayNum = parseInt(day, 10);
        if (dayNum > 31 || dayNum < 1) {
          e.preventDefault();
          e.target.value = '';
          setFilterValue(null);
          const event = { target: { value: "" } };
          onColumnFilterChange(event, col, "field", filterType);
          setTimeout(() => {
            e.target.setSelectionRange(0, 0);
          }, 0);
          return;
        }
      }
      
      const firstSlashIndex = rawValue.indexOf('/');
      if (firstSlashIndex !== -1 && cursorPosition > firstSlashIndex + 1 && cursorPosition <= firstSlashIndex + 3) {
        const dayPart = rawValue.substring(firstSlashIndex + 1, cursorPosition);
        if (dayPart && dayPart.length === 1) {
          const nextChar = rawValue.charAt(cursorPosition);
          if (nextChar && nextChar !== '/') {
            const potentialDay = parseInt(dayPart + nextChar, 10);
            if (potentialDay > 31 || potentialDay < 1) {
              e.preventDefault();
              e.target.value = rawValue.substring(0, firstSlashIndex + 1) + dayPart;
              setFilterValue(null);
              const event = { target: { value: "" } };
              onColumnFilterChange(event, col, "field", filterType);
              setTimeout(() => {
                e.target.setSelectionRange(firstSlashIndex + 2, firstSlashIndex + 2);
              }, 0);
              return;
            }
          }
        }
      }
    }
    
    
    if (parts.length === 3) {
      const month = parts[0];
      const day = parts[1];
      const year = parts[2];
      
      if (month && (month.length > 2 || (month && (parseInt(month, 10) > 12 || parseInt(month, 10) < 1)))) {
        e.preventDefault();
        e.target.value = '';
        setFilterValue(null);
        const event = { target: { value: "" } };
        onColumnFilterChange(event, col, "field", filterType);
        return;
      }
      
      if (day && (day.length > 2 || (day && (parseInt(day, 10) > 31 || parseInt(day, 10) < 1)))) {
        e.preventDefault();
        e.target.value = '';
        setFilterValue(null);
        const event = { target: { value: "" } };
        onColumnFilterChange(event, col, "field", filterType);
        return;
      }
      
      if (year && year.length > 4) {
        e.preventDefault();
        e.target.value = '';
        setFilterValue(null);
        const event = { target: { value: "" } };
        onColumnFilterChange(event, col, "field", filterType);
        return;
      }
    }
  };

  const handleSelectChange = (e, col, type) => {
    setFilterType(e.target.value);
    onColumnFilterChange(e, col, type, e.target.value);
  };

  const renderInput = () => {
    if (col.inputType === "date") {
      return (
        <DatePicker
          selected={filterValue}
          onChange={handleDateChange}
          onChangeRaw={handleDateRawChange}
          onKeyDown={(e) => {
            // Prevent invalid month and day input from being entered
            const input = e.target;
            const currentValue = input.value;
            const cursorPos = input.selectionStart;
            
            // Only validate if key is a number
            if (!/[0-9]/.test(e.key)) {
              return;
            }
            
            const firstSlashIndex = currentValue.indexOf('/');
            const secondSlashIndex = currentValue.indexOf('/', firstSlashIndex + 1);
            
            // Check if typing in month field (before first slash)
            if (cursorPos <= 2 && firstSlashIndex === -1) {
              const newValue = currentValue.substring(0, cursorPos) + e.key + currentValue.substring(cursorPos);
              const monthPart = newValue.split('/')[0];
              
              // If month would have more than 2 digits, prevent input and clear
              if (monthPart && monthPart.length > 2) {
                e.preventDefault();
                input.value = '';
                setFilterValue(null);
                const event = { target: { value: "" } };
                onColumnFilterChange(event, col, "field", filterType);
                return false;
              }
              
              // If month would be > 12, prevent input
              if (monthPart && monthPart.length === 2) {
                const monthNum = parseInt(monthPart, 10);
                if (monthNum > 12 || monthNum < 1) {
                  e.preventDefault();
                  // Clear the field if invalid
                  input.value = '';
                  setFilterValue(null);
                  const event = { target: { value: "" } };
                  onColumnFilterChange(event, col, "field", filterType);
                  return false;
                }
              }
            }
            
            // Check if typing in day field (between first and second slash)
            if (firstSlashIndex !== -1 && cursorPos > firstSlashIndex + 1 && 
                (secondSlashIndex === -1 || cursorPos <= secondSlashIndex)) {
              const newValue = currentValue.substring(0, cursorPos) + e.key + currentValue.substring(cursorPos);
              const parts = newValue.split('/');
              
              if (parts.length >= 2) {
                const dayPart = parts[1];
                
                // If day would have more than 2 digits, prevent input
                if (dayPart && dayPart.length > 2) {
                  e.preventDefault();
                  input.value = '';
                  setFilterValue(null);
                  const event = { target: { value: "" } };
                  onColumnFilterChange(event, col, "field", filterType);
                  return false;
                }
                
                // If day would be > 31, prevent input and clear
                if (dayPart && dayPart.length === 2) {
                  const dayNum = parseInt(dayPart, 10);
                  if (dayNum > 31 || dayNum < 1) {
                    e.preventDefault();
                    // Clear the field if invalid
                    input.value = '';
                    setFilterValue(null);
                    const event = { target: { value: "" } };
                    onColumnFilterChange(event, col, "field", filterType);
                    return false;
                  }
                }
              }
            }
            
            // Check if typing in year field (after second slash)
            if (secondSlashIndex !== -1 && cursorPos > secondSlashIndex + 1) {
              const newValue = currentValue.substring(0, cursorPos) + e.key + currentValue.substring(cursorPos);
              const parts = newValue.split('/');
              
              if (parts.length >= 3) {
                const yearPart = parts[2];
                
                // If year would have more than 4 digits, prevent input and clear
                if (yearPart && yearPart.length > 4) {
                  e.preventDefault();
                  input.value = '';
                  setFilterValue(null);
                  const event = { target: { value: "" } };
                  onColumnFilterChange(event, col, "field", filterType);
                  return false;
                }
              }
            }
          }}
          portalId="root portal"
          popperModifiers={[
            {
              name: "preventOverflow",
              options: {
                boundary: "clippingParents",
                rootBoundary: "viewport",
                tether: true,
                altAxis: true,
                padding: {
                  top: 8,
                  bottom: 8,
                  left: 8,
                  right: 8,
                },
              },
            },
            {
              name: "flip",
              options: {
                fallbackPlacements: ["bottom-start", "bottom-end", "top-start", "top-end"],
                boundary: "clippingParents",
                rootBoundary: "viewport",
                padding: {
                  top: 8,
                  bottom: 8,
                  left: 8,
                  right: 8,
                },
              },
            },
            {
              name: "offset",
              options: {
                offset: [0, 8],
              },
            },
          ]}
          popperPlacement="bottom-start"
          // popperContainer={CalendarContainer}
          className="border-0 w-100 date-picker"
          placeholderText="MM/DD/YYYY"
        />
      );
    }
    return (
      <Input
        type={col.inputType === "number" ? "text" : col.inputType}
        placeholder={col.text}
        value={filterValue}
        onChange={(e) => handleInputChange(e, col, "field")}
      />
    );
  };

  return (
    <InputGroup className="table-filter-group">
      {renderInput()}
      <div style={{ zIndex: 0 }}>
        <Input
          type="select"
          className="table-filter-icon cursor-pointer"
          value={filterType}
          onChange={(e) => handleSelectChange(e, col, "select")}
        >
          <option value={1}>Equals to</option>
          {col.inputType === "text" && <option value={3}>Contains</option>}
          {col.inputType === "text" && <option value={4}>Starts with</option>}
          {col.inputType === "text" && <option value={5}>Ends with</option>}
          {(col.inputType === "number" || col.inputType === "date") && (
            <option value={6}>Less than or equals to</option>
          )}
          {(col.inputType === "number" || col.inputType === "date") && (
            <option value={7}>Greater than or equals to</option>
          )}
        </Input>
      </div>
    </InputGroup>
  );
};

export default ColumnFilters;
